import styled from "styled-components";
import { color } from "../../styles";

interface SearchBarWrapperProps {
  isFocus: Boolean;
}

export const SearchBarWrapper = styled.div<SearchBarWrapperProps>`
  padding: 0 12px;
  border: 1px solid ${color.secondary.GREY_4};
  border-color: ${(props) => (props.isFocus ? color.primary.BLUE_B100 : color.secondary.GREY_4)};
  box-shadow: ${(props) => (props.isFocus ? '0 0 0 2px rgba(0, 88, 160, 0.12)' : 'none')};
  border-radius: 5px;
  display: flex;
  gap: 12px;
  width: 600px;
  height: 34px;
  align-items: center;
  box-sizing: border-box;
`;

export const SearchText = styled.input`
  color: ${color.secondary.CHARCOAL};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  width: 100%;
  border: none;

  &::placeholder {
    color: ${color.secondary.DARK_GREY};
  }

  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
  }
`;
